import { ComponentType } from 'react';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SignupPage from './pages/SignupPage';
import CallbackPage from './pages/CallbackPage';
import WelcomeScreen from './pages/WelcomeScreen';
import Dashboard from './pages/Dashboard';
import AccountSettings from './pages/AccountSettings';
import SubscriptionPage from './pages/SubscriptionPage';
import WorkLogAnalytics from './pages/WorkLogAnalytics';
import InvoicePage from './pages/InvoicePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';
import GDPRPage from './pages/GDPRPage';
import NotFoundPage from './pages/NotFoundPage';
import FreeToolsPage from './pages/FreeToolsPage';
import BestToolSEOPage from './pages/BestToolSEOPage';
import FeatureSEOLandingPage from './pages/FeatureSEOLandingPage';

export interface RouteConfig {
  name: string;
  path: string;
  component: ComponentType<any>;
  requiresAuth?: boolean;
  isAuthRoute?: boolean; // Routes that should redirect if user is already authenticated
  exact?: boolean;
}

export const routes: RouteConfig[] = [
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
    isAuthRoute: true,
  },
  {
    name: 'Forgot Password',
    path: '/forgot-password',
    component: ForgotPasswordPage,
    isAuthRoute: true,
  },
  {
    name: 'Reset Password',
    path: '/reset-password',
    component: ResetPasswordPage,
    isAuthRoute: true,
  },
  {
    name: 'Signup',
    path: '/signup',
    component: SignupPage,
    isAuthRoute: true,
  },
  {
    name: 'Callback',
    path: '/callback',
    component: CallbackPage,
  },
  {
    name: 'Welcome',
    path: '/welcome',
    component: WelcomeScreen,
    requiresAuth: true,
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
    requiresAuth: true,
  },
  {
    name: 'Account Settings',
    path: '/account-settings',
    component: AccountSettings,
    requiresAuth: true,
  },
  {
    name: 'Subscription',
    path: '/subscription',
    component: SubscriptionPage,
    requiresAuth: true,
  },
  {
    name: 'Work Log Analytics',
    path: '/worklog',
    component: WorkLogAnalytics,
    requiresAuth: true,
  },
  {
    name: 'Invoice',
    path: '/invoice',
    component: InvoicePage,
    requiresAuth: true,
  },
  {
    name: 'Privacy Policy',
    path: '/privacy-policy',
    component: PrivacyPolicy,
  },
  {
    name: 'Blog',
    path: '/blog',
    component: BlogPage,
  },
  {
    name: 'Blog Post',
    path: '/blog/:postId',
    component: BlogPage,
  },
  {
    name: 'About Us',
    path: '/about',
    component: AboutPage,
  },
  // SEO feature landing pages (same app, SEO content wrapper)
  { name: 'Pomodoro Timer', path: '/pomodoro-timer', component: FeatureSEOLandingPage },
  { name: 'Deep Work', path: '/deep-work', component: FeatureSEOLandingPage },
  { name: 'Focus Sounds', path: '/focus-sounds', component: FeatureSEOLandingPage },
  { name: 'Task Manager', path: '/task-manager', component: FeatureSEOLandingPage },
  { name: 'Productivity Tools', path: '/productivity-tools', component: FeatureSEOLandingPage },
  { name: 'Distraction Blocker', path: '/distraction-blocker', component: FeatureSEOLandingPage },
  { name: 'Work Session Timer', path: '/work-session-timer', component: FeatureSEOLandingPage },
  {
    name: 'GDPR Compliance',
    path: '/gdpr',
    component: GDPRPage,
  },
  {
    name: 'Free Tools',
    path: '/tools',
    component: FreeToolsPage,
  },
  {
    name: 'Best Tool SEO',
    path: '/tools/best-:topic',
    component: BestToolSEOPage,
  },
  {
    name: 'Free Tool',
    path: '/tools/:toolId',
    component: FreeToolsPage,
  },
  {
    name: 'Free Tool (programmatic SEO)',
    path: '/tools/:toolId/:slug',
    component: FreeToolsPage,
  },
  {
    name: 'Landing',
    path: '/',
    component: LandingPage,
    exact: true,
  },
  {
    name: 'Custom 404',
    path: '/custom-404',
    component: NotFoundPage,
  },
];

